import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import Switch from '@material-ui/core/Switch';
import { generateData } from './utils';
import { fetchCustomType } from '../../actions/CustomTypeAction';
import Loader from '../../component/Loader/Loader';
import CButton from '../../component/Button';
import Modal from '../../component/Modal/Modal';
import ArrowBack from '../../asset/arrow-back.svg';
import ContinueIcon from '../../asset/continue.svg';
import { CStandardInput } from '../../component/Input';
import { fetchAllCustomers } from '../../actions/customersAction';
import './content.css';
import { AutocompleteSelect } from '../../component/Select';

const useStyles = makeStyles({
  root: {
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },
    '& .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      fontFamily: 'Poppins',
      height: '38px',
      padding: '10px 16px'
    },
    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '5px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  }
});

const mapToTable = (users) => {
  const data = [];

  if (!users || users.length === 0) {
    return data;
  }

  users.forEach(({ _id, name, surname, role, email }, index) => {
    const fullName = name?.concat(' ', surname);

    data.push({
      _id,
      email,
      fullName,
      key: index,
      role
    });
  });

  return data;
};

const ContentDrawer = ({ onClose, visible, setVisible, onContentSave, selectedFilter }) => {
  const [contentModelChosen, setContentModelChosen] = useState(null);
  const [isFakeContentGeneratorEnabled, setIsFakeContentGeneratorEnabled] = useState(false);
  const [contentName, setContentName] = useState('');
  const [selectedUserId, setSelectedUserId] = useState('');
  const dispatch = useDispatch();
  const customTypes = useSelector(({ customType }) => customType.customTypes);
  const history = useHistory();
  const goToAllUsers = () => {
    history.push('/users');
  };
  const users = useSelector(({ customer }) => customer.customers);
  const data = mapToTable(users);
  const activeLanguages = useSelector(({ language }) => language.activeLanguages);
  const classes = useStyles();
  const sortUsersAlphabetically = data.sort((a, b) =>
    a?.email?.toLowerCase().localeCompare(b?.email?.toLowerCase())
  );
  const currentUser = data.filter((user) => user._id === selectedUserId)[0];

  useEffect(() => {
    async function load() {
      dispatch(fetchCustomType());
      dispatch(fetchAllCustomers());
    }

    load();
  }, [dispatch]);

  useEffect(() => {
    if (visible === false) return;
    setSelectedUserId(null);
    setContentModelChosen(null);
    setIsFakeContentGeneratorEnabled(false);
  }, [visible]);

  if (!customTypes) {
    return <Loader />;
  }

  const content = customTypes.find((item) => item.name === contentModelChosen);

  const openDetail = (item) => {
    history.push(`/content/${item}`);
  };
  const onSave = async () => {
    const emptyContentFromCustomType = () => {
      const languages = {};
      activeLanguages.forEach((language) => {
        languages[language.key] = {};
      });

      const draft = {
        api_id: content.api_id,
        customType: content,
        custom_type: content._id,
        data: languages,
        name: contentName,
        project: content.project,
        userId: selectedUserId
      };

      const contentFieldNames = Object.keys(content.template);
      contentFieldNames.forEach((fieldName) => {
        let fieldData = '';
        if (isFakeContentGeneratorEnabled) {
          const { template } = content;
          const contentFieldInfo = template[fieldName];
          fieldData = generateData(contentFieldInfo);
        }

        Object.keys(languages).forEach((language) => {
          draft.data[language][fieldName] = fieldData;
        });
      });

      return draft;
    };
    const contentData = await onContentSave(emptyContentFromCustomType());
    const contentId = contentData.data.content._id;

    setSelectedUserId(null);
    setContentModelChosen(null);
    setVisible(false);
    setIsFakeContentGeneratorEnabled(false);
    openDetail(contentId);
  };

  const onBack = () => {
    setContentModelChosen(null);
  };

  const ContentModelList = () => {
    const contentList = [...new Set(customTypes.map((item) => item.name))];

    const filteredContentList =
      !selectedFilter?.[0] || selectedFilter?.[0] === 'All'
        ? contentList
        : contentList.filter((content) => {
            return content.toLowerCase().includes(selectedFilter?.[0]?.toLowerCase());
          });

    return [...(filteredContentList.length === 0 ? contentList : filteredContentList)]
      .sort((a, b) => a.localeCompare(b))
      .map((name, index) => {
        return (
          <div
            key={index}
            className="modal-list-wrapper"
            onClick={() => setContentModelChosen(name)}
          >
            <p key={index} className="modal-list-item">
              {name}
            </p>
            <img alt="continue icon" src={ContinueIcon} />
          </div>
        );
      });
  };

  return (
    <Modal
      footerActions={
        contentModelChosen && (
          <>
            <CButton
              htmlType="submit"
              onClick={(e) => {
                onClose();
                e.preventDefault();
              }}
              size="large"
              type="secondary"
            >
              Cancel
            </CButton>
            <CButton htmlType="submit" onClick={onSave} size="large" type="primary">
              Create
            </CButton>
          </>
        )
      }
      handleClose={onClose}
      isModalOpen={visible}
      styles={{
        '& .MuiDialogContent-root': {
          marginBottom: '30px',
          maxHeight: '280px',
          minHeight: '150px',
          overflow: 'auto',
          paddingTop: '0px'
        },
        width: '520px'
      }}
      titleContent={
        contentModelChosen ? (
          <div>
            <div className="modal-header-go-back" onClick={onBack}>
              <img alt="arrow back" src={ArrowBack} />
              <span>Back</span>
            </div>
            <span className="modal-title">Create Content For &quot;{contentModelChosen}&quot;</span>
          </div>
        ) : (
          <>
            <span className="modal-title">Create Content</span>
            <p
              style={{
                color: '#9BA0AD',
                fontSize: '12px',
                marginBottom: '0px',
                marginTop: '20px'
              }}
            >
              Choose Content Model
            </p>
          </>
        )
      }
    >
      {!contentModelChosen ? (
        <ContentModelList />
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginTop: '10px',
            minHeight: '150px'
          }}
        >
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-content-drawer-name"
            id="standard-input-content-drawer-name"
            label="Name"
            onChange={(event) => setContentName(event.target.value)}
            size="large"
            style={{ marginBottom: '10px' }}
            width="true"
          />
          <div style={{ marginBottom: '10px' }}>
            <h4
              style={{
                color: 'rgba(0, 0, 0, 0.54)',
                fontFamily: 'Poppins',
                fontWeights: 400
              }}
            >
              Fake Content
            </h4>
            <Switch
              checked={isFakeContentGeneratorEnabled}
              color="primary"
              onChange={() => setIsFakeContentGeneratorEnabled((value) => !value)}
            />
          </div>
          {content?.visibility === 'private' ? (
            <AutocompleteSelect
              getOptionLabel={(option) => option?.email}
              id="autocomplete-content-drawer-private"
              onSelect={(user) => setSelectedUserId(user._id)}
              onViewAll={goToAllUsers}
              options={sortUsersAlphabetically}
              placeholderValue={currentUser?.email || 'Select User'}
            />
          ) : null}
        </div>
      )}
    </Modal>
  );
};

export default ContentDrawer;
